import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { useFavoriteProductsList } from '@features/favorite';
import { FavoriteProductsList } from '@shared/ui/favorite';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';

export const FavoritePage = () => {
  const set = useNavbar();
  const { data, onLoadMore, isLoading, hasNextPage } =
    useFavoriteProductsList();

  useEffect(() => {
    set.favorite();
  }, []);

  return (
    <>
      <div className="hidden lg:block container max-w-7xl mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Избранное</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Избранное
          </h1>
        </div>
      </div>

      <div className="h-full flex-grow container max-w-7xl lg:flex lg:flex-col lg:items-center lg:justify-center lg:mx-auto lg:min-h-[500px] lg:pb-32 lg:mt-12">
        <FavoriteProductsList
          items={data}
          onLoadMore={onLoadMore}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
        />
      </div>
    </>
  );
};
